var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaHospitalAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1015 2.60729C12.3388 2.46453 12.6356 2.46422 12.8732 2.60648L17.1555 5.16976C17.8343 5.5761 18.2499 6.30913 18.2499 7.10031L18.25 20H6.75L6.75001 7.09825C6.75 6.30875 7.16379 5.57701 7.84035 5.1701L12.1015 2.60729ZM11.4192 8.66887C11.4191 8.25466 11.0833 7.91891 10.6691 7.91895C10.2549 7.91898 9.91915 8.2548 9.91919 8.66902V13.8315C9.91915 14.2457 10.2549 14.5816 10.6691 14.5816C11.0833 14.5816 11.4191 14.2459 11.4192 13.8317L11.4194 12.0003H13.5806L13.5806 13.8316C13.5806 14.2458 13.9164 14.5816 14.3306 14.5816C14.7448 14.5816 15.0806 14.2458 15.0806 13.8316L15.0806 8.66895C15.0806 8.25473 14.7448 7.91895 14.3306 7.91895C13.9164 7.91895 13.5806 8.25473 13.5806 8.66895V10.5003H11.4194L11.4192 8.66887Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8.17627H4.75781C3.51517 8.17627 2.50781 9.18363 2.50781 10.4263V17.7501C2.50781 18.9927 3.51517 20.0001 4.75781 20.0001H5.75V8.17627Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2416 20.0001H19.25V8.17627H20.2416C21.4842 8.17627 22.4916 9.18363 22.4916 10.4263V17.7501C22.4916 18.9927 21.4842 20.0001 20.2416 20.0001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaHospitalAlt);
export default __webpack_public_path__ + "static/media/FaHospitalAlt.7b3abde6b74cdaea10be73feccd2a395.svg";
export { ForwardRef as ReactComponent };